import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseRentIndexationTemplates = [
  {
    id: '-221001',
    language: Language.EN,
    subject: 'Annual rent indexation',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>Your rent will be indexed.</p>
          <p>More details here: {{pdfLink}}.</p>
          <p>Thank you for adjusting your direct debit accordingly.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-221002',
    language: Language.FR,
    subject: 'Indexation annuelle du loyer',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Votre loyer sera indexé.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Merci d'ajuster votre domiciliation en conséquence.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-221003',
    language: Language.NL,
    subject: 'Jaarlijkse indexering van de huurprijs',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Uw huur wordt geïndexeerd.</p>
          <p>Meer details hier: {{pdfLink}}.</p>
          <p>Bedankt voor het aanpassen van uw automatische incasso.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-221004',
    language: Language.DE,
    subject: 'Jährliche Mietindexierung',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_RENT_INDEXATION,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ihre Miete wird indexiert.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Bitte passen Sie Ihre Daueraufträge entsprechend an.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
